import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/animeData';

export default function HotRecommend() {
  const hotList = animeList.filter((a) => a.rating >= 9.0).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全网高分好评动漫精选</p>
        </div>
        <Link
          to="/category/riman"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {hotList.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
              <img
                src={anime.cover}
                alt={anime.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                {anime.rating}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                <span className="text-white text-xs whitespace-nowrap">{anime.episodes}</span>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
              {anime.title}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              {anime.tags.slice(0, 2).map((tag) => (
                <span key={tag} className="text-xs text-foreground-400 whitespace-nowrap">{tag}</span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}